import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { PageSkeleton } from '@/components/ui/page-skeleton';
import { VALORES_PESTANA_FICHA } from '@/features/recet-datos/utils/pestanas';

const fichaSearchSchema = z.object({
  tab: z.enum(VALORES_PESTANA_FICHA).optional().catch(undefined),
});

export const Route = createFileRoute('/admin/recet/fichas/$id')({
  validateSearch: fichaSearchSchema,
  pendingComponent: PageSkeleton,
});
